import { render, staticRenderFns } from "./viewComplaints.vue?vue&type=template&id=d092fbac&scoped=true"
import script from "./viewComplaints.vue?vue&type=script&lang=js"
export * from "./viewComplaints.vue?vue&type=script&lang=js"
import style0 from "./viewComplaints.vue?vue&type=style&index=0&id=d092fbac&prod&lang=css"
import style1 from "./viewComplaints.vue?vue&type=style&index=1&id=d092fbac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d092fbac",
  null
  
)

export default component.exports